import { render, staticRenderFns } from "./ModalEnviarReadequacao.vue?vue&type=template&id=88e79796&scoped=true"
import script from "./ModalEnviarReadequacao.vue?vue&type=script&lang=js"
export * from "./ModalEnviarReadequacao.vue?vue&type=script&lang=js"
import style0 from "./ModalEnviarReadequacao.vue?vue&type=style&index=0&id=88e79796&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e79796",
  null
  
)

export default component.exports